import React from "react";
import PropTypes from "prop-types";
import { intlShape } from "react-intl";
import { Field, Select } from "cxa-components";
import PieChart from "./PieChart";
import PieLegend from "./PieLegend";
import { CATEGORY_BACKGROUND_COLOR } from "./constants";

const leftNavContainerStyle = { position: "sticky", top: "0" };
const periodListStyle = {
  width: "210px",
  marginLeft: "auto",
  marginRight: "auto",
};
const footNoteStyle = {
  padding: "0.6em",
  backgroundColor: CATEGORY_BACKGROUND_COLOR,
  fontSize: "0.75em",
};

class LeftNavigation extends React.Component {
  componentDidMount() {
    const benefitPeriods = this.props.trs.benefitPeriods;
    if (benefitPeriods && benefitPeriods.length > 0) {
      this.props.getTrsDetail(benefitPeriods[0].benefitPeriod);
    }
  }

  handleBenefitPeriodChange = e => {
    const benefitPeriod = e.target.value;
    this.props.getTrsDetail(benefitPeriod);
  };

  renderSelect = props => {
    return (
      <Select {...props}>
        {this.props.trs.benefitPeriods.map(item => (
          <option key={item.benefitPeriod} value={item.benefitPeriod}>
            {item.benefitPeriod}
          </option>
        ))}
      </Select>
    );
  };

  render() {
    const {
      detail: { totalRewards, categoryList, footNotes },
    } = this.props.trs;
    const currencySubCategory =
      categoryList &&
      categoryList
        .filter(cat => Array.isArray(cat.subCategoryList)) // Ensure subCategoryList is an array
        .flatMap(cat => cat.subCategoryList) // Flatten all subcategories into a single array
        .find(subCat => subCat.subCategoryName === "Currency Display");

    const currencySubSubCategory =
      currencySubCategory &&
      Array.isArray(currencySubCategory.subSubCategoryList) &&
      currencySubCategory.subSubCategoryList.find(x => x.subSubCategoryName === "Currency Display");
    const currencyCode = (currencySubSubCategory && currencySubSubCategory.entitlement) || "SGD";

    return totalRewards ? (
      <div style={leftNavContainerStyle}>
        <div style={periodListStyle}>
          <Field
            name="benefitPeriod"
            field={this.renderSelect}
            id="benefitPeriod"
            onChange={this.handleBenefitPeriodChange}
            onBlur={this.handleBenefitPeriodChange}
          />
        </div>
        <PieChart data={totalRewards} currencyCode={currencyCode} intl={this.props.intl} />
        <div style={{ position: "relative", top: "-130px" }}>
          <PieLegend
            categories={totalRewards.categorySummaries || []}
            currencyCode={currencyCode}
            intl={this.props.intl}
          />
          {footNotes && (
            <div style={footNoteStyle}>
              {this.props.intl.formatMessage({
                id: footNotes,
                defaultMessage: footNotes,
              })}
            </div>
          )}
        </div>
      </div>
    ) : (
      ""
    );
  }
}

LeftNavigation.propTypes = {
  getTrsDetail: PropTypes.func,
  trs: PropTypes.object,
  intl: intlShape.isRequired,
};
export default LeftNavigation;



// WEBPACK FOOTER //
// ./components/employee/benefits/trs/LeftNavigation.jsx